<button mat-icon-button class="closer" (click)="close()">
  <mat-icon>close</mat-icon>
</button>
<h2 mat-dialog-title>Manage views</h2>

<div mat-dialog-content class="manage-views-content">

  <!-- Current view + primary actions -->
  <div class="current-view-bar">
    <div class="current-view-label">
      Current view: <span class="current-view-name">{{ currentView?.templateViewName || 'None' }}</span>
    </div>
    <div class="current-view-actions">
      @if (canEditCurrent) {
        <button mat-stroked-button (click)="updateCurrent()">Update current view</button>
      }
      <button mat-raised-button color="primary" (click)="saveAsNew()">Save as new view</button>
    </div>
  </div>

    <!-- MY VIEWS -->
    <div class="views-section">
      <div class="section-header">
        <span class="section-title">My views</span>
        <button mat-icon-button class="sort-btn" [class.sort-active]="mySort > 0"
                matTooltip="Sort alphabetically" (click)="cycleMySort()">
          <mat-icon>{{ sortIcon(mySort) }}</mat-icon>
        </button>
      </div>
      <div class="views-list">
        @for (v of myViews; track v.templateViewID) {
          <div class="view-row">
            <mat-slide-toggle class="row-toggle" color="primary"
                              [checked]="v.subscribed !== 0"
                              (change)="toggleSubscription(v, $event.checked)"
                              [matTooltip]="v.subscribed !== 0 ? 'Shown in view list' : 'Hidden from view list'">
            </mat-slide-toggle>
            <div class="view-info">
              <div class="view-name-line">
                <span class="view-name">{{ v.templateViewName }}</span>
                @if (v.description) {
                  <span class="view-desc-sep">|</span>
                  <span class="view-desc">{{ v.description }}</span>
                }
                @if (v.templateViewID === data.activeTemplateViewID) {
                  <span class="viewing-indicator">● viewing</span>
                }
              </div>
              <div class="view-meta-line">
                <span class="view-badge" [ngClass]="badgeClass(v)">{{ visibilityLabel(v) }}</span>
                <span class="view-meta">{{ ownerLabel(v) }}</span>
                <span class="view-meta">{{ v.updatedDate | date:'mediumDate' }}</span>
              </div>
            </div>
            <!-- Delete lives inside Settings (permission-gated there) — one
                 consistent row shape for every section -->
            <div class="view-actions">
              <button mat-icon-button matTooltip="Settings" (click)="openSettings(v)">
                <mat-icon>settings</mat-icon>
              </button>
            </div>
          </div>
        } @empty {
          <div class="empty-row">You don't have any views for this grid yet.</div>
        }
      </div>
    </div>

    <!-- AVAILABLE VIEWS -->
    <div class="views-section">
      <div class="section-header">
        <span class="section-title">Available views</span>
        <button mat-icon-button class="sort-btn" [class.sort-active]="availableSort > 0"
                matTooltip="Sort alphabetically" (click)="cycleAvailableSort()">
          <mat-icon>{{ sortIcon(availableSort) }}</mat-icon>
        </button>
      </div>
      <div class="views-list">
        @for (v of availableViews; track v.templateViewID) {
          <div class="view-row">
            @if (isGlobal(v)) {
              <mat-slide-toggle class="row-toggle" color="primary"
                                [checked]="true" [disabled]="true"
                                matTooltip="Always shown">
              </mat-slide-toggle>
            } @else {
              <mat-slide-toggle class="row-toggle" color="primary"
                                [checked]="v.subscribed !== 0"
                                (change)="toggleSubscription(v, $event.checked)"
                                [matTooltip]="v.subscribed !== 0 ? 'Shown in view list' : 'Hidden from view list'">
              </mat-slide-toggle>
            }
            <div class="view-info">
              <div class="view-name-line">
                <span class="view-name">{{ v.templateViewName }}</span>
                @if (v.description) {
                  <span class="view-desc-sep">|</span>
                  <span class="view-desc">{{ v.description }}</span>
                }
                @if (v.templateViewID === data.activeTemplateViewID) {
                  <span class="viewing-indicator">● viewing</span>
                }
              </div>
              <div class="view-meta-line">
                @if (showBadge(v, false)) {
                  <span class="view-badge" [ngClass]="badgeClass(v)">{{ visibilityLabel(v) }}</span>
                }
                <span class="view-meta">{{ ownerLabel(v) }}</span>
                <span class="view-meta">{{ v.updatedDate | date:'mediumDate' }}</span>
              </div>
            </div>
            <div class="view-actions">
              <button mat-icon-button matTooltip="Settings" (click)="openSettings(v)">
                <mat-icon>settings</mat-icon>
              </button>
            </div>
          </div>
        } @empty {
          <div class="empty-row">No views have been shared with you.</div>
        }
      </div>
    </div>

</div>
